import React, { useState, useEffect, useContext } from "react";
import AdminContext from "../../../StateContext/Application";
import { apiurl } from "../../../../../path";
// 18-09
import { Edit32WHITE,
  Approved32,
  PDF32,
  Excel32,
  JPG32,
  PNG32,
  UpdateWhite32, } from "../../../../../public/LoginImages/importimages";
// 18-09
import FundCreation from "../../BudgetManagement/FundManage/FundCreation.js";

// 08-10 status color
const STATUS_STYLES = {
  pending: {
    label: "Pending",
    color: "#F59E0B",
    textColor: "#E8890C",
    bg: "#FFFFFF",
    img: "/Pending icon 32 Size.png",
  },
  sendback: {
    label: "Send Back",
    color: "#0D6EFD",
    textColor: "#0D6EFD",
    bg: "#FFFFFF",
    img: "/send back 32 size.png",
  },
  approved: {
    label: "Approved",
    color: "#39B54A",
    textColor: "#39B54A",
    bg: "#FFFFFF",
    img: "/Approved  32 Size.png",
  },
  rejected: {
    label: "Rejected",
    color: "#FF5C6C",
    textColor: "#FF5C6C",
    bg: "#FFFFFF",
    img: "/Reject 32 size.png",
  },
};
 
const StatusBadge = ({ status }) => {
  const key = (status || "").replace(/\s+/g, "").toLowerCase();
 
  const s = STATUS_STYLES[key] || STATUS_STYLES.pending;
 
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
        minWidth: "95px",
        padding: "5px 12px",
        border: `1px solid ${s.color}`,
        borderRadius: "20px",
        color: s.textColor,
        backgroundColor: s.bg,
        fontSize: "12px",
        fontWeight: "600",
        whiteSpace: "nowrap",
      }}
    >
      <img
        src={s.img}
        alt={s.label}
        style={{ width: "18px", height: "18px", objectFit: "contain" }}
      />
      {s.label}
    </span>
  );
};
 

// 19-10 file type icon
const getFileIcon = (fileName) => {
  const ext = (fileName || "").split(".").pop().toLowerCase();
  if (ext === "pdf") return PDF32;
  if (ext === "xls" || ext === "xlsx") return Excel32;
  if (ext === "jpg" || ext === "jpeg") return JPG32;
  if (ext === "png") return PNG32;
  return UpdateWhite32; // default icon
};
const FundList = () => {
  const context = useContext(AdminContext);
  const { GetNewFundOutwardList,Usermenu,FundApproval } = context;
  const [fund, setFundList] = useState([]);
  const [filteredBills, setFilteredBills] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  const [searchTerm, setSearchTerm] = useState("");
 const [statusFilter, setStatusFilter] = useState("All");
//  18-09
const [menuData, setMenuData] = useState({});
const [showEditForm, setShowEditForm] = useState(false);
const [editFundData, setEditFundData] = useState(null);
  const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);

  

  const getFundList = async () => {
    let data = await GetNewFundOutwardList();
    console.log("data", data);
    const sortedData = [...data].sort(
      (a, b) => new Date(b.Date) - new Date(a.Date),
    );
    setFundList(sortedData);
    setFilteredBills(sortedData);
  };
  useEffect(() => {
    getFundList();
  }, []);
  let FundList = [];
  if (fund.length > 0) {
    FundList = fund;
  }
  

  // above usefect comment for sattus filter 16-09
 useEffect(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
 
    const filtered = fund.filter((bill) => {
        const matchesSearch = Object.values(bill).some((val) =>
            (val || "").toString().toLowerCase().includes(lowerSearchTerm)
        );
 
        const matchesStatus =
            statusFilter === "All" ||
            (bill.Status || "").toLowerCase() === statusFilter.toLowerCase();
 
        return matchesSearch && matchesStatus;
    });
 
    setFilteredBills(filtered);
    setCurrentPage(1);
}, [searchTerm, statusFilter, fund]);
  const getFundPageNumbers = () => {
    const maxVisiblePages = 5;

    // 5 ya usse kam pages
    if (totalPages <= maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    // Starting pages
    // 1 2 3 4 5 ... Last
    if (currentPage <= 3) {
      return [1, 2, 3, 4, 5, "...", totalPages];
    }

    // Last pages
    // ... 16 17 18 19 20
    if (currentPage >= totalPages - 2) {
      return [
        "...",
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      ];
    }

    // Middle pages
    // ... 4 5 6 7 8 ... 20
    return [
      "...",
      currentPage - 2,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      currentPage + 2,
      "...",
      totalPages,
    ];
  };



  // 18-09
  useEffect(() => {
  const getMenu = async () => {
    const res = await Usermenu();
    setMenuData(res?.Data || {});
  };
  getMenu();
}, []);

const isMaker =
  menuData?.Department_Name === "State Maker" &&
  menuData?.Role === "State Maker";

  const handleEditFund = (fund) => {
  setEditFundData(fund);
  setShowEditForm(true);
};

const handleApproveFund = async (fund) => {
  const shouldProceed = window.confirm("Are you sure you want to approve this Fund?");
  if (!shouldProceed) return;

  try {
    const response = await FundApproval([fund.FundID], "Approved", "");
    if (response?.message) alert(response.message);
    else if (response?.error) alert(response.error);
    getFundList(); // refresh list
  } catch (err) {
    console.error("Error approving Fund:", err);
    alert("An error occurred while approving.");
  }
};
  return (

    <>
     {!showEditForm ? (
    <div
       style={{
        background: "#ffffff",
        width: "100%",
        minHeight: "90vh",
        //29/10
        padding: "20px 25px",
        boxSizing: "border-box",
        fontFamily: "Inter, sans-serif",
        overflowY: "auto",
      }}
    >
      <div
        style={{
        width: "100%",
        background: "#EEF1F6",
        borderRadius: "12px",
        padding: "20px 15px",
        boxSizing: "border-box",
        boxShadow: "0 3px 10px rgba(0, 0, 0, 0.10)",
        border: "1px solid #E1E6EF",
      }}
      >
        
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "12px",
          boxSizing: "border-box",
        }}
      >
        <h5
          style={{
            margin: 0,
            fontSize: "17px",
            fontWeight: "700",
            color: "#111",
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
    src="/Fund-Inward-List-32.png"
    alt="img"
   style={{height:"28px", width:"28px", marginLeft:"10px"}}
  />
          Fund Outward List
        </h5>
         <div style={{display:"flex",justifyContent:"center",gap:"10px"}}>
        <div style={{ position: "relative", width: "250px" }}>
          <img
            src={"/Search-32.png"}
            alt="Search Icon"
            style={{
              position: "absolute",
              left: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              width: "16px",
              height: "16px",
              opacity: 0.7,
            }}
          />
          <input
            type="text"
            placeholder="Search Fund..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              width: "100%",
              height: "36px",
              padding: "6px 10px 6px 32px",
              border: "1px solid #d0d7df",
              borderRadius: "6px",
              background: "#ffffff",
              outline: "none",
              fontSize: "12px",
              boxSizing: "border-box",
            }}
          />
        </div>
        <select
    value={statusFilter}
    onChange={(e) => setStatusFilter(e.target.value)}
    style={{
        width: "140px",
        height: "36px",
        marginLeft: "10px",
        border: "1px solid #d5dce5",
        borderRadius: "8px",
        padding: "0 10px",
        fontSize: "12px",
        outline: "none",
        background: "#fff",
        cursor: "pointer"
    }}
>
    <option value="All">All Status</option>
    <option value="Pending">Pending</option>
    <option value="SendBack">SendBack</option>
    <option value="Approved">Approved</option>
    <option value="Rejected">Rejected</option>
</select></div>
      </div>
      <div
        style={{
          width: "100%",
          maxWidth: "100%",
          background: "#ffffff",
          borderRadius: "12px",
          padding: "12px",
          boxSizing: "border-box",
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.12)",
          margin: "0 auto",
        }}
      >
        <div
          style={{
            width: "100%",
            overflowX: "auto",
            overflowY: "hidden",
            border: "1px solid #d7e1f0",
            borderRadius: "6px",
            boxSizing: "border-box",
          }}
        >
          <table
            style={{
              width: "100%",
              minWidth: "500px",
              maxWidth: "500px",
              borderCollapse: "separate",
              borderSpacing: 0,
              tableLayout: "auto",
              textAlign: "center",
            }}
          >
            <thead>
              <tr
                style={{
                  //28/10
                  backgroundColor: "#2D79D9",
                  color: "white",
                  fontSize: "14px",
                  fontWeight: "400",
                  whiteSpace: "nowrap",
                  height: "38px",
                }}
              >
                <th
                  style={{
                    padding: "8px 12px",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  Sr No.
                </th>
                <th
                  style={{
                    padding: "8px 12px",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  Year
                </th>
                <th
                  style={{
                    padding: "8px 12px",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  GR Number
                </th>
                <th
                  style={{
                    padding: "8px 12px",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  Letter Number
                </th>
                <th
                  style={{
                    padding: "8px 12px",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  Date
                </th>
                <th
                  style={{
                    padding: "8px 12px",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  UTR Number
                </th>
                <th
                  style={{
                    padding: "8px 12px",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  Bank UTR Date
                </th>
                <th
                  style={{
                    padding: "8px 12px",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  Fund Amount
                </th>
                <th
                  style={{
                    padding: "8px 12px",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  Upload Copy
                </th>
                <th style={{padding:"8px 12px",textAlign:"center",whiteSpace:"nowrap"}}>Status</th>
                <th style={{padding:"8px12px", textAlign:"center",whiteSpace:"nowrap"}}>Remark</th>
                {/* 18-09 */}
                {isMaker && <th style={{ padding: "8px 12px", textAlign: "center", whiteSpace: "nowrap" }}>Action</th>}
{isMaker && <th style={{ padding: "8px 12px", textAlign: "center", whiteSpace: "nowrap" }}>Approve</th>}
              </tr>
            </thead>
            {currentBills?.map((fund, index) => {
              const bgColor = index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
              return (
                <tbody>
                  <tr
                    style={{
                      fontSize: "13px",
                      fontWeight: "500",
                      textAlign: "center",
                      whiteSpace: "break-spaces",
                       backgroundColor: index % 2 === 0 ? "#E5F4FB" : "#CEE4F1",
                    }}
                  >
                    <td style={{ padding: "10px", whiteSpace: "nowrap" }}>
                      {index + 1}
                    </td>
                    <td style={{ padding: "10px", whiteSpace: "nowrap" }}>
                      {fund.Year}
                    </td>
                    <td style={{ padding: "10px", whiteSpace: "nowrap" }}>
                      {fund.GRNumber}
                    </td>
                    <td style={{ padding: "10px", whiteSpace: "nowrap" }}>
                      {fund.LetterNumber}
                    </td>
                    <td style={{ padding: "10px", whiteSpace: "nowrap" }}>
                      {fund.Date?.split("T")[0].replace(" ")}
                    </td>
                    <td style={{ padding: "10px", whiteSpace: "nowrap" }}>
                      {fund.UTRNumber}
                    </td>
                    <td style={{ padding: "10px", whiteSpace: "nowrap" }}>
                      {fund.BankUTRDate?.split("T")[0].replace(" ")}
                    </td>
                    <td style={{ padding: "10px", whiteSpace: "nowrap" }}>
                      {/* {fund.FundAmount} */}₹
                      {Number(fund.FundAmount || 0).toLocaleString("en-IN")}
                    </td>
                            {/* 19-10 */}
                                    <td style={{ padding: "8px", minWidth: "160px", width: "160px", maxWidth: "160px", whiteSpace: "nowrap", textAlign: "center" }}>
                  {fund.UploadCopy ? (
                    <a
                      href={`${apiurl}/FundDocs/${fund.UploadCopy}`}
                      target="_blank"
                      rel="noreferrer"
                      title={fund.UploadCopy}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "5px",
                        width: "100%",
                        overflow: "hidden",
                        textDecoration: "none",
                        color: "#0d6efd",
                      }}
                    >
                      <img
                        src={getFileIcon(fund.UploadCopy)}
                        alt="file icon"
                        style={{ width: "20px", height: "20px", flexShrink: 0 }}
                      />
                      Upload Copy
                    </a>
                  ) : (
                    <span style={{ color: "#d9534f", fontWeight: 700 }}>No File</span>
                  )}
                </td>
                    {/* <td style={{padding:"10px",whiteSpace:"nowrap"}}>{fund.Status}</td> */}
                    {/* 08-10 status color */}
                      <td style={{ padding: "10px", textAlign: "center" }}>
  <StatusBadge status={fund. Status} />
</td>
 
                    <td style={{padding:"10px",whiteSpace:"nowrap"}}>{fund.Remark || "-"}</td>
                    {/* 18-09 */}
                    {isMaker && (
  <td style={{ padding: "10px", textAlign: "center" }}>
    <button
      onClick={() => handleEditFund(fund)}
      disabled={fund.Status !== "SendBack"}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "5px",
        margin: "auto",
        padding: "6px 12px",
        background:
          fund.Status === "SendBack" ? "#0D6EFD" : "rgba(141,141,141,0.97)",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        fontSize: "13px",
        fontWeight: "600",
        cursor: fund.Status === "SendBack" ? "pointer" : "not-allowed",
      }}
    >
      <img src={Edit32WHITE} alt="Edit" style={{ width: "14px", height: "14px" }} />
      Edit
    </button>
  </td>
)}

{isMaker && (
  <td style={{ padding: "10px", textAlign: "center" }}>
    <button
      onClick={() => handleApproveFund(fund)}
      disabled={fund.Status !== "SendBack"}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "5px",
        margin: "auto",
        padding: "6px 12px",
        background:
          fund.Status === "SendBack" ? "#39B54A" : "rgba(141,141,141,0.97)",
        color: "#fff",
        border: "none",
        borderRadius: "6px",
        fontSize: "13px",
        fontWeight: "600",
        cursor: fund.Status === "SendBack" ? "pointer" : "not-allowed",
      }}
    >
      <img src={Approved32} alt="Approve" style={{ width: "14px", height: "14px" }} />
      Approve
    </button>
  </td>
)}
                  </tr>
                </tbody>
              );
            })}
          </table>
          
     {(!Array.isArray(currentBills) || currentBills.length === 0) && (
                        <div
                            style={{
                                position: "sticky",
                                left: 0,
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                height: "150px",
                                boxSizing: "border-box",
                                backgroundColor: "#ffffff",
                                color: "#333",
                                fontSize: "14px",
                                fontWeight: 500,
                            }}
                        >
                            No data available
                        </div>
                    )}
 


        </div>
       

        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "15px",
            padding: "10px 5px",
            boxSizing: "border-box",
          }}
        >
          {/* Showing Entries */}
          <div
            style={{
              fontSize: "13px",
              color: "#333",
              whiteSpace: "nowrap",
            }}
          >
            Showing {filteredBills?.length === 0 ? 0 : indexOfFirstBill + 1} to{" "}
            {Math.min(indexOfLastBill, filteredBills?.length || 0)} of{" "}
            {filteredBills?.length || 0} entries
          </div>

          {/* Pagination Right Side */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "18px",
            }}
          >
            {/* Previous */}
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              style={{
                border: "none",
                background: "transparent",
                color: "#2ea4e7",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
                fontSize: "12px",
                padding: 0,
                opacity: currentPage === 1 ? 0.5 : 1,
              }}
            >
              ‹ Previous
            </button>

            {/* Page Numbers */}
            {getFundPageNumbers().map((pageNumber, index) => {
              if (pageNumber === "...") {
                return (
                  <span
                    key={`ellipsis-${index}`}
                    style={{
                      fontSize: "13px",
                      color: "#444",
                    }}
                  >
                    ...
                  </span>
                );
              }

              return (
                <button
                  key={pageNumber}
                  onClick={() => setCurrentPage(pageNumber)}
                  style={{
                    border: "none",
                    background: "transparent",
                    padding: 0,
                    color: currentPage === pageNumber ? "#2ea4e7" : "#444",
                    cursor: "pointer",
                    fontSize: "13px",
                    fontWeight: currentPage === pageNumber ? "600" : "400",
                    textDecoration:
                      currentPage === pageNumber ? "underline" : "none",
                  }}
                >
                  {pageNumber}
                </button>
              );
            })}

            {/* Next */}
            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages || totalPages === 0}
              style={{
                border: "none",
                background: "transparent",
                color: "#2ea4e7",
                cursor:
                  currentPage === totalPages || totalPages === 0
                    ? "not-allowed"
                    : "pointer",
                fontSize: "12px",
                padding: 0,
                opacity:
                  currentPage === totalPages || totalPages === 0 ? 0.5 : 1,
              }}
            >
              Next ›
            </button>
          </div>
        </div>
      </div>
    </div></div>
      ) : (
      <FundCreation
        isEdit={true}
        fundData={editFundData}
        onSuccess={() => {
          setShowEditForm(false);
          getFundList(); // refresh table
        }}
        onCancel={() => {
          setShowEditForm(false);
        }}
      />
    )}
    </>
  );
};

export default FundList;
